import React from 'react';
import { cn } from '../lib/utils';
import { statusLabel } from '../lib/roles';

const STATUS_STYLES = {
  Draft: 'bg-[hsl(var(--muted))] text-[hsl(var(--muted-foreground))] border-transparent',
  SubmittedToManager: 'bg-[hsl(var(--teal)/0.16)] text-[hsl(var(--teal))] border-[hsl(var(--teal)/0.35)]',
  SubmittedToAdmin: 'bg-[hsl(var(--warning)/0.16)] text-[hsl(var(--warning))] border-[hsl(var(--warning)/0.4)]',
  Approved: 'bg-[hsl(var(--success)/0.16)] text-[hsl(var(--success))] border-[hsl(var(--success)/0.35)]',
  Rejected: 'bg-[hsl(var(--danger)/0.16)] text-[hsl(var(--danger))] border-[hsl(var(--danger)/0.35)]',
  Sent: 'bg-[hsl(var(--primary)/0.18)] text-[hsl(var(--primary))] border-[hsl(var(--primary)/0.35)] dark:text-[hsl(var(--foreground))]',
  Won: 'bg-[hsl(var(--success)/0.2)] text-[hsl(var(--success))] border-[hsl(var(--success)/0.4)]',
  Lost: 'bg-[hsl(var(--danger)/0.16)] text-[hsl(var(--danger))] border-[hsl(var(--danger)/0.35)]',
};

export function StatusPill({ status, className = '' }) {
  return (
    <span
      data-testid={`status-pill-${status}`}
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium',
        STATUS_STYLES[status] || STATUS_STYLES.Draft, className
      )}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-80" />
      {statusLabel(status)}
    </span>
  );
}
